import { useQuery } from '@tanstack/react-query';
import { IGetPendingReviewPayload } from '../shiftReviewApi';
import { shiftReviewService } from '../shiftReviewService';

export const useGetShiftPendingReviews = ({ limit = 10, page = 1 }: IGetPendingReviewPayload) => {
  return useQuery({
    enabled: true,
    queryFn: async () => shiftReviewService.getShiftPendingReviews({ limit, page }),
    queryKey: ['getShiftPendingReviews', { limit, page }],
    retry: false,
  });
};
